import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Box,
} from "@mui/material";


function TableData({ rows, resetPageTrigger, columns }) {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);

  useEffect(() => {
    setPage(0);
  }, [resetPageTrigger]);

  const paginatedRows = rows?.slice(page * 10, page * 10 + 10) || [];

  const headers =
    columns?.length > 0
      ? columns
      : rows?.[0]
        ? Object.keys(rows[0]).map((key) => ({ key, label: key }))
        : [];



  // Reset pagination when trigger changes
  useEffect(() => {
    setPage(0);
  }, [resetPageTrigger]);



  return (
    <Paper
      elevation={3}
      sx={{
        backgroundColor: "#202940", // dark card
        color: "white",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <TableContainer sx={{ borderRadius: "0" }}>
        <Table sx={{ minWidth: 650 }} aria-label="info table">
          <TableHead sx={{ display: "table-header-group" }}>
            <TableRow>
              {headers.map((header) => (
                <TableCell
                  key={header.key}
                  sx={{
                    fontWeight: "bold",
                    textTransform: "capitalize",
                    padding: "12px 16px",
                    color: "#fff!important",
                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                  }}
                >
                  {header.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {paginatedRows.map((row, index) => (
              <TableRow key={index}>
                {headers.map((header) => (
                  <TableCell
                    key={header.key}
                    sx={{
                      padding: "12px 16px",
                      color: "#fff!important",
                      borderBottom: "1px solid rgba(255,255,255,0.05)",
                    }}
                  >
                    {row[header.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Wrap pagination in a dark box */}
      <Box
        sx={{
          backgroundColor: "#202940",
          borderTop: "1px solid rgba(255,255,255,0.1)",
            display: "flex",              // 👈 σιγουρεύει ότι όλο το pagination κάθεται αριστερά
          justifyContent: "flex-start", // 👈
        }}
      >
        <TablePagination
          component="div"
          count={rows.length}
          page={page}
          onPageChange={(_, newPage) => setPage(newPage)}
          rowsPerPage={10} // fixed
          rowsPerPageOptions={[]} // hides the selector
          labelDisplayedRows={({ from, to, count }) =>
            t("trafficMonitoring.infohub.tableRowsRange", {
              from,
              to,
              count: count !== -1 ? count : t("trafficMonitoring.infohub.tableRowsMore"),
            })
          }
            slotProps={{
            toolbar: {
              sx: {
                justifyContent: "flex-start", // ΑΡΙΣΤΕΡΑ
                pl: 2,
              },
            },
          }}
          sx={{
            color: "#a9a9a9",
            "& .MuiTablePagination-selectLabel": {
              color: "#a9a9a9",
            },
            "& .MuiTablePagination-input": {
              color: "#a9a9a9",
            },
            "& .MuiSelect-icon": {
              color: "#a9a9a9",
            },
            "& .MuiSelect-iconStandard": {
              color: "#a9a9a9",
            },
            "& svg": {
              color: "#a9a9a9",
            },
          }}
        />
      </Box>
    </Paper>
  );
}

export default TableData;
